import { render, staticRenderFns } from "./GroupsNew.vue?vue&type=template&id=cc568ca6&scoped=true&"
import script from "./GroupsNew.vue?vue&type=script&lang=js&"
export * from "./GroupsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc568ca6",
  null
  
)

export default component.exports